var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { Select } from 'syf-component-library/ui/atoms';
const SelectWithFocus = (_a) => {
    var { options } = _a, rest = __rest(_a, ["options"]);
    const selectInputRef = useRef(null);
    const ref = rest.selectInputRef || selectInputRef;
    const newOptions = useMemo(() => options.map((option) => (Object.assign(Object.assign({}, option), { onClick: () => {
            var _a, _b;
            // gets called whenever an option is selected with both clicks or keyboard.
            (_a = option.onClick) === null || _a === void 0 ? void 0 : _a.call(option);
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.focus();
        } }))), [options, ref]);
    return _jsx(Select, Object.assign({}, rest, { options: newOptions, selectInputRef: ref }));
};
export default SelectWithFocus;
